import React, { useEffect, useState } from "react";
import LoginBackgroundNew from "../../assets/images/LoginBackgroundNew.png";
import HeaderLogoNew from "../../assets/images/HeaderLogoNew.svg";
import Logo from "../../assets/images/Logo.svg";
import {
  Button,
  FormFieldSet,
  InputFieldShadow,
  showToast,
} from "../../components";
import LoginBg from "../../components/Backgrounds/LoginBg";
import { useDispatch, useSelector } from "react-redux";
import { loginStart, clearError } from "../../redux/slices/auth/authSlice";
import { getItem, setItem } from "../../utils/localStorageUtils";
import { vi } from "@faker-js/faker";

const Login = () => {
  const ENV = import.meta.env.VITE_APP_ENV || "local";
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const [email, setEmail] = useState(
    // ENV !== "production" ? "demo@tektreeinc.com" : ""
    ""
  ); //demo@tektreeinc.com
  const [password, setPassword] = useState(
    // ENV !== "production" ? "Demo@123" : ""
    ""
  ); //Demo@123
  const [showPassword, setShowPassword] = useState(false);

  const [rememberMe, setRememberMe] = useState(["1"]);

  const localCredentials = getItem("credentials") || [];

  const loweremail = email.toLowerCase().trim();
  const validEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(loweremail);

  const loading = auth.loading;

  const filteredEmails =
    localCredentials &&
      loweremail &&
      loweremail.length > 0 &&
      localCredentials.length > 0
      ? localCredentials
        .filter((cred) => cred.email.toLowerCase().includes(loweremail))
        .slice(0, 10)
      : [];

  const handleRememberMe = (rememberMe) => {
    setRememberMe(rememberMe);
  };

  useEffect(() => {
    if (localCredentials && localCredentials.length === 1) {
      setEmail(localCredentials[0].email);
    }
  }, []);

  const handleLogin = () => {
    if (!validEmail) {
      showToast("Your email id is not valid", "error", 5000);
      return;
    } else if (password.length <= 0) {
      showToast("Please enter password", "error", 5000);
      return;
    } else {
      const isRememberMe = rememberMe.includes("1") ? true : false;
      dispatch(
        loginStart({ email: loweremail, password, rememberMe: isRememberMe })
      ); // Dispatch loginStart with credentials
      //add localstore portal=wf
      // localStorage.setItem("portal", "wf");
      // setItem("portal", "wf"); // commented 071025 because of default not wf
      // Dispatch custom event to notify AppRoutes of the change
      // window.dispatchEvent(new CustomEvent("portalChanged"));
    }
  };
  const handleSuggesstionClick = (cred) => {
    setEmail(cred.email);
  };

  useEffect(() => {
    if (auth.error) {
      showToast(auth.error, "error", 5000);
      dispatch(clearError());
    }
  }, [auth.error, dispatch]);
  return (
    <div
      className="w-full min-h-screen bg-no-repeat bg-cover bg-center bg-fixed"
      style={{ backgroundImage: `url(${LoginBackgroundNew})` }}
    >
      <div className="xs:p-5 md:p-10 gap-10 min-h-screen flex flex-col flex-1">
        <div>
          <div className="select-none">
            <img src={HeaderLogoNew} alt="Kult Works" className="" />
          </div>
        </div>
        <div className="flex-1 flex items-center justify-between gap-10 xs:flex-col lg:flex-row text-white">
          <div className=" xs:hidden lg:flex flex-col gap-10">
            <h1 className="text-shadow font-semibold mb-3 xs:text-5xl sm:text-6xl md:text-[86px]">
              Welcome...
            </h1>
            <p className="xs:text-base md:text-[16px] leading-[24px] w-full max-w-[650px] font-light">
              Supercharge Your Recruitment with Next-Gen Technology.Unlock the
              power of AI-driven, all-in-one ATS designed to help staffing
              agencies recruit smarter, faster, and more efficiently.
            </p>
            <div className="xs:mt-4 lg:mt-4">
              <Button title={"Learn More"} size="xl" />
            </div>
          </div>
          <div className="flex-1 flex justify-end items-center ">
            <div className="w-full xs:min-w-[280px] sm:min-w-[420px] max-w-[560px]">
              <LoginBg className={"rounded-3xl w-full"}>
                {/* <div className="bg-dark"> */}
                <div className="w-full flex-1 flex flex-col items-center justify-between xs:px-4 sm:px-10  pt-16 pb-20">
                  <img
                    src={Logo}
                    alt="Kult Works Logo"
                    className="w-[60px] lg:w-[80px] h-[60px] lg:h-[80px]"
                  />
                  <div>
                    <h2 className="text-center text-white xs:text-3xl text-4xl font-semibold my-10 ">
                      Sign in
                    </h2>
                  </div>
                  <form
                    className="w-full max-w-80 flex flex-col gap-8"
                    onSubmit={(e) => {
                      e.preventDefault();
                    }}
                  >
                    <div className="relative">
                      <InputFieldShadow
                        label="Enter Email ID"
                        icon={"account_circle"}
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />

                      {/* Suggestions dropdown */}
                      {filteredEmails.length > 0 &&
                        !filteredEmails.some(
                          (cred) => cred.email.toLowerCase() === loweremail
                        ) && (
                          <ul className="absolute z-50 w-full bg-white text-black border border-gray-700 rounded-md mt-2 shadow-lg max-h-48 overflow-y-auto">
                            {filteredEmails.map((cred, index) => (
                              <li
                                key={index}
                                onClick={() => handleSuggesstionClick(cred)}
                                className="px-3 py-2 cursor-pointer transition-colors hover:bg-gray-200"
                              >
                                {cred.email}
                              </li>
                            ))}
                          </ul>
                        )}
                    </div>

                    <InputFieldShadow
                      label="Enter Password"
                      // icon={"shield_lock"}
                      icon={
                        <span
                          onClick={() => setShowPassword(!showPassword)}
                          className="cursor-pointer"
                        >
                          {showPassword ? "visibility_off" : "visibility"}
                        </span>
                      }
                      type={showPassword ? "text" : "password"}
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <div className="-mt-8">
                      <FormFieldSet
                        type="checkbox"
                        size="md"
                        title=""
                        placeholder="Enter Zip Code"
                        options={[{ label: "Remember me", value: "1" }]}
                        values={rememberMe}
                        onChange={handleRememberMe}
                        multiple
                      />
                    </div>

                    <Button
                      title={loading ? "Loading..." : "Login"}
                      disabled={loading}
                      onClick={() => handleLogin()}
                    />
                  </form>
                </div>
                {/* </div> */}
              </LoginBg>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
